/*
 * @Descripttion: 
 * @version: 
 * @Author: 
 * @Date: 2022-09-14 19:04:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-10-24 14:19:15
 */

export default {
    Home: {
        List: {
            Title: 'Confirmed Merchants',
            Tip: 'The following payment successful list is collected by the system within recent 30 days records. It does not mean that the virtual cards are limited to the following merchants. For card BINs that are published recently, the records mignt be less. Note: The actual payment pass rate of virtual card is limited by many factors (such as KYC or risk control policies of each merchant, etc.), and FotonCard DOSE NOT guarantee 100% payment pass rate in all scenarios.',
            QuickSearch: 'Quick Search',
            MerchantName: 'Merchant Name',
            MerchantNameInputTip: 'Enter key words like NETFLIX / Line, etc',
            PaymentCurrency: 'Payment Currency',
            Search: 'Search',
            SuccessfulBINS: 'Successful BINS',
            SuccessfulCurrency: 'Successful Currency',
            SuccessfullyPaid: 'Successfully paid in the last 30 days',
            Bin428837: {
                AmazonUSPayment: 'Amazon US payment',
                AmazonUKPayment: 'Amazon UK payment',
                AmazonGERPayment: 'Amazon GER payment',
                EBayPayment: 'eBay payment',
                EstyPurchasePayment: 'Etsy Purchase Payment',
                GoolgePlayPayment: 'Goolge play payment',
                PayAtShopee: 'Pay at Shopee',
                GoogleAdsPayment: 'Google ads payment',
                FacebookAdsPayment: 'Facebook ads payment',
                KindlePayment: 'Kindle payment',
                WalmartPayment: 'Walmart payment',
                PayPalBainding: 'PayPal binding',
                TaobaoPayment: 'Taobao payment',
                AliexpressPayment: 'Aliexpress payment'
            },
            Bin222929: {
                AmazonUSPayment: 'mazon US payment',
                AmazonUKPayment: 'Amazon UK payment',
                AmazonGERPayment: 'Amazon GER payment',
                EBayPayment: 'eBay payment',
                EstyPurchasePayment: 'Etsy Purchase Payment',
                GoolgePlayPayment: 'Goolge play payment',
                AlipayHKBindingAndPayAtHKTVmall: 'AlipayHK binding and pay at HKTVmall',
                WechatBindingAndPayment: 'Wechat binding and payment',
                BestBuyUSAPaymentWithAnyBillingAddress: 'BestBuy USA payment with any billing address',
                PayAtNIKEWithAnyBillingAddress: 'Pay at NIKE with any billing address',
                PayAtAdidasHKSite: 'Pay at adidas HK site',
                PayAtFordeal: 'Pay at Fordeal',
                PayAtShopee: 'Pay at Shopee',
                GoogleAdsPayment: 'Google ads payment',
                FacebookAdsPayment: 'Facebook ads payment',
                TelegramPremiumPayment: 'Telegram premium payment',
                TaobaoPayment: 'Taobao payment',
                AliexpressPayment: 'Aliexpress payment',
                PayPalPainding: 'PayPal binding',
                LazadaPayment: 'Lazada payment',
                AppleUS: 'APPLE US payment'
            },
            Bin472593: {
                EstyPurchasePayment: 'Esty purchase payment',
                EBayPayment: 'eBay payment',
                GoogleAdsPayment: 'Google ads payment',
                FacebookAdsPayment: 'Facebook ads payment',
                AIRBNBPayment: 'AIRBNB payment',
                AmazonUSPayment: 'Amazon US payment',
                GoolgePlayPayment: 'Goolge play payment',
                PayPalBainding: 'PayPal binding',
                ShopeePay: 'Shopee Pay',
                TelegramPremiumHongKong: 'Telegram Premium(HongKong)'
            },
            Bin556766: {
                AmazonPayment: 'Amazon payment',
                AliExpressPayment: 'AliExpress payment',
                eBayPayment: 'eBay payment',
                MercariPayment: 'Mercari payment',
                EtsyPayment: 'Etsy payment',
                PoshMarkPayment: 'PoshMark payment',
                AlibabaPayment: 'Alibaba payment',
                WalmartPayment: 'Walmart payment',
                FacebookAdsPayment: 'Facebook Ads payment',
                TikTokAdsPayment: 'TikTok Ads payment',
                GoogleAdsPayment: 'Google Ads payment',
                PinterestAdsPayment: 'Pinterest Ads payment',
                SupremePayment: 'Supreme payment',
                FootLockerPayment: 'Foot Locker payment',
                YezzyPayment: 'Yezzy payment',
                NikePayment: 'Nike payment',
                FootactionPayment: 'Footaction payment',
                GooglePlayPayment: 'Google Play payment',
                AppleStorePayment: 'Apple Store payment',
                NetflixPayment: 'Netflix payment'
            }
        }
    }

}